import React from 'react';
import '../styles/Crew.scss';

const Crew = () => {
    const crew = [
        { name: "Cpt. Sarah Vance", role: "Commander", bio: "Ex-NASA pilot with 12 Mars landings." },
        { name: "Dr. Aris Thorne", role: "Chief Science Officer", bio: "Astrobiologist & Xenobystroky expert." },
        { name: "Elena K.", role: "Guest Experience", bio: "Ensuring your zero-G champagne is perfect." }
    ];

    return (
        <section className="crew">
            <div className="container">
                <h2>Meet Your Crew</h2>
                <div className="crew-grid">
                    {crew.map((member, i) => (
                        <div key={i} className="crew-card">
                            <div className="avatar-placeholder"></div>
                            <h3>{member.name}</h3>
                            <h4>{member.role}</h4>
                            <p>{member.bio}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Crew;
